import { InfraredFlight } from "@nova/protobuf"
import { useEffect, useRef, useState } from "react"
import { InspectorPanelAccordionSlider } from "../../accordion/InspectorPanelAccordionSlider"
import { InfraredFlightUpdates } from "../InspectorPanelHotspotLayer"

// divided by 100
const DEFAULT_SENSITIVITY = 70

export const InspectorPanelHotspotLayerFiltersSensitivity = ({
    flight,
    updateFn,
    sliderTitle = "Sensitivity",
}: {
    flight: InfraredFlight
    updateFn: (updates: InfraredFlightUpdates) => void
    sliderTitle?: string
}) => {
    // This should only be called by the useEffect that listens to changes to `entity`!
    const [localSensitivity, setLocalSensitivity] = useState<number | undefined>(
        flight?.sensitivity || 0.7
    )
    const localSensitivityRef = useRef<number>(undefined)

    const updateSensitivity = (sensitivity: number) => {
        updateFn({ sensitivity })
        setLocalSensitivity(sensitivity)
    }

    /**
     * If the entity is changed externally (not via the Inspector Panel), this
     * will ensure that those changes update the Inspector Panel. Make sure
     * you follow the pattern below if new properties get added to InfraredFlight.
     */
    useEffect(() => {
        if (!flight) return

        // Update local sensitivity.
        const newSensitivity = flight.sensitivity
        if (newSensitivity !== undefined && newSensitivity !== localSensitivityRef.current) {
            setLocalSensitivity(newSensitivity)
            localSensitivityRef.current = newSensitivity
        }
    }, [flight])

    if (!localSensitivity) return null

    return (
        <div className="mb-1 flex flex-col gap-2">
            {/* Warning Message */}

            <InspectorPanelAccordionSlider
                title={sliderTitle}
                resetValue={sliderTitle === "Sensitivity" ? DEFAULT_SENSITIVITY : undefined}
                existingSliderValue={Math.round(localSensitivity * 100)}
                minSliderValue={10}
                maxSliderValue={100}
                onValueChanged={(sensitivity) => updateSensitivity(sensitivity / 100)}
                createTextualValue={(sensitivity) => `${(sensitivity / 100).toFixed(2)}`}
            />
        </div>
    )
}
